// src/runtime/ContentRuntime/platforms/wechat/config.ts
// ============================================
// 微信公众号配置（冻结版本 v1.0）
// ============================================

// proxyUrl 必须使用相对路径，由 Vite dev proxy（本地开发）或 nginx 反向代理（生产）处理
// 这样避免跨域问题和端口暴露，符合 os.xshetech.com 反向代理架构
export const WeChatConfig = {
  appId: import.meta.env.VITE_WECHAT_APP_ID || '',
  // P12 短板4/8：AppSecret 由服务端 Vault(XEAOS/Config/WeChat.md)托管，经 /wechat-api 代理代填。
  // 前端禁保存/编译 AppSecret（VITE_ 前缀会进 bundle 造成泄露），此处固定为空串，不走任何 env 读取。
  appSecret: '',
  proxyUrl: '/wechat-api',
  get apiUrl() {
    return this.proxyUrl;
  },
};

// 微信公众号 API 端点（使用官方正确路径）
export const WeChatEndpoints = {
  // 获取 access_token
  token: '/cgi-bin/token',
  // 草稿箱：新增草稿
  draftAdd: '/cgi-bin/draft/add',
  // 发布：从草稿发布（使用 freepublish/submit 正确端点，原 draft/publish 不存在）
  freepublishSubmit: '/cgi-bin/freepublish/submit',
  // 查询发布状态
  freepublishGet: '/cgi-bin/freepublish/get',
  // 删除草稿
  draftDelete: '/cgi-bin/draft/delete',

  // ✅ 端点构建方法
  tokenUrl: (appId: string, secret: string) =>
    `${WeChatConfig.apiUrl}/cgi-bin/token?grant_type=client_credential&appid=${appId}&secret=${secret}`,

  draftAddUrl: (token: string) =>
    `${WeChatConfig.apiUrl}/cgi-bin/draft/add?access_token=${token}`,

  freepublishSubmitUrl: (token: string) =>
    `${WeChatConfig.apiUrl}/cgi-bin/freepublish/submit?access_token=${token}`,

  freepublishGetUrl: (token: string) =>
    `${WeChatConfig.apiUrl}/cgi-bin/freepublish/get?access_token=${token}`,
} as const;
